import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "inherit",
      d: "M14.52 3h-1.04A1.48 1.48 0 0 0 12 4.48v10.04c0 .817.663 1.48 1.48 1.48h1.04A1.48 1.48 0 0 0 16 14.52V4.48A1.48 1.48 0 0 0 14.52 3M2 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M2.52 3H1.48A1.48 1.48 0 0 0 0 4.48v10.04C0 15.337.663 16 1.48 16h1.04A1.48 1.48 0 0 0 4 14.52V4.48A1.48 1.48 0 0 0 2.52 3",
      class: "fill-secondary"
    }, null, -1),
    _createElementVNode("path", {
      fill: "inherit",
      d: "M10.75 7H9V5.25a1 1 0 0 0-2 0V7H5.25a1 1 0 0 0 0 2H7v1.75a1 1 0 1 0 2 0V9h1.75a1 1 0 1 0 0-2",
      class: "fill-primary"
    }, null, -1),
    _createElementVNode("path", {
      fill: "inherit",
      d: "M14 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
      class: "fill-secondary"
    }, null, -1)
  ])))
}
export default { render: render }